import axios from "~/axios";

const resetPassword = async(baseUrl, username) => {
    let ret = (await axios.post(`${baseUrl}/passwordReset`, {username})).data;

    return ret;
};

const updatePassword = async(baseUrl, { token, password, passwordConfirmation}) => {
    let ret = (await axios.post(`${baseUrl}/passwordUpdate`, {token, password, password_confirmation: passwordConfirmation })).data;
    return ret;
};


export default {
    resetPassword,
    updatePassword
}